import { Dialog as HeadlessDialog } from '@headlessui/react';
import styled, { css, keyframes } from 'styled-components';

import { ModalVariant } from '../../model/types/modal.interface';

const fadeIn = keyframes`
	from {
		opacity: 0;
	}

	to {
		opacity: 1;
	}
`;

const slideInRight = keyframes`
	from {
		transform: translateX(100%);
	}

	to {
		transform: translateX(0);
	}
`;

export const Dialog = styled(HeadlessDialog)<{ variant: ModalVariant }>`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	display: flex;
	justify-content: ${({ variant }) => (variant === 'side' ? 'flex-end' : 'center')};
	align-items: ${({ variant }) => (variant === 'side' ? 'stretch' : 'center')};
	background-color: rgba(0, 0, 0, 0.4);
	z-index: ${({ theme: { zIndex } }) => zIndex.modal};
	padding: ${({ variant }) => (variant === 'side' ? '0' : '0 16px')};
	animation: ${fadeIn} 0.2s ease-out;
`;

export const Panel = styled(HeadlessDialog.Panel)<{ variant: ModalVariant }>`
	background-color: ${({ theme: { modal } }) => modal.background};
	border-radius: ${({ theme: { modal } }) => modal.radius};

	${({ variant, theme: { modal } }) =>
		variant === 'side' &&
		css`
			height: 100%;
			margin-left: auto;
			border-radius: 0;
			border-left: 1px solid ${modal.border};
			animation: ${slideInRight} 0.24s ease-out;
		`}
`;
